import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { getRetailerDocument } from '../../selectors/retailer';
import { resolveRouteRetailer } from '../../shared/resolve-routes';
import { RouterLink } from '../../styled-components/components/Link';

const Seller = () => {
  const { t } = useTranslation('common');
  const retailer = useSelector(getRetailerDocument);

  if (!retailer) return null;

  const { name, logo, position, slug } = retailer;
  const city = position ? position.city : null;

  const link = `${resolveRouteRetailer()}/${slug}`;

  return (
    <div className="convert-card-body">
      <div className="convert-card-section">
        <div data-am-columnrow="always">
          <div className="column">
            <div className="font-size-small-rem-md">
              <RouterLink to={link} title={t('Read more about this', { ns: 'common', name })}>
                {name}
              </RouterLink>
              <div>
                <i className="icon-map-pin m-r-mini text-action" />
                {city}
              </div>
            </div>
          </div>
          <div className="column minimal">
            {logo && (
              <img
                src={`${logo}?w=80&format=png`}
                srcSet={`${logo}?w=160&format=png 2x`}
                alt={name}
                className="l-block"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Seller;
